import { SurveyCaption, SurveyDashboardPage, SurveysByUserResponse } from '@/graphql/generated/graphql';
import { create } from 'zustand';

export interface SchoolFilter {
  id: number;
  name: string;
}

type SurveyDashboardStore = {
  selectedComponent: string;
  currentTab: 'survey-responses' | 'response-table';
  selectedSchoolsIds: string[];
  currentSurvey: SurveysByUserResponse | null;
  captions: SurveyCaption[];
  isEmpty: boolean;
  page: SurveyDashboardPage | null;
  updateSelectedComponent: (selectedComponent: string) => void;
  uploadCurrentTab: (currentTab: 'survey-responses' | 'response-table') => void;
  updateSelectedSchools: (selectedSchoolsIds: string[]) => void;
  updateCurrentSurvey: (currentSurvey: SurveysByUserResponse | null) => void;
  updateCaptions: (captions: SurveyCaption[]) => void;
  updateIsEmpty: (isEmpty: boolean) => void;
  updatePage: (page: SurveyDashboardPage) => void;
};

export const useSurveyDashboardStore = create<SurveyDashboardStore>()((set) => ({
  selectedComponent: 'Questions',
  currentTab: 'survey-responses',
  selectedSchoolsIds: [],
  captions: [],
  currentSurvey: null,
  isEmpty: false,
  page: null,
  uploadCurrentTab: (currentTab) => set({ currentTab }),
  updateSelectedComponent: (selectedComponent) => set({ selectedComponent }),
  updateSelectedSchools: (selectedSchoolsIds) => set({ selectedSchoolsIds }),
  updateCurrentSurvey: (currentSurvey) => set({ currentSurvey }),
  updateCaptions: (captions) => set({ captions }),
  updateIsEmpty: (isEmpty) => set({ isEmpty }),
  updatePage: (page) => set({ page }),
}));
